import htmlDecode from "../../utils/htmlDecode";
import createSmartIntersector from "../../utils/createSmartIntersector";
import evaluateLoadedScripts from "../../utils/pageScripts";
import { READ_ARTICLE_EVENT } from "../../consts";

function publishReadArticle({ eventBus, postUrl, elid, headline, settings }) {
    eventBus.publish(READ_ARTICLE_EVENT, {
        url: postUrl,
        id: elid,
        headline: headline,
        trackPageView: settings.engine.countKeepReadingAsPageview,
    });
}

function parseContents(readMoreContainer) {
    const contentContainer = readMoreContainer.parentElement.querySelector(".content-container");
    const keepReadingContent =
        readMoreContainer.querySelector("template") ||
        readMoreContainer.querySelector('script[type="keep-reading-content"]');

    if (keepReadingContent.tagName === "TEMPLATE") {
        keepReadingContent.content.querySelectorAll("style").forEach((style) => {
            const clonedStyle = style.cloneNode(true);
            document.head.appendChild(clonedStyle);
            style.remove();
        });
    }

    contentContainer.innerHTML = htmlDecode(keepReadingContent.innerHTML);
    evaluateLoadedScripts(contentContainer);
}

function showMore(widgetBody) {
    const YAxis = document.documentElement.scrollTop;
    widgetBody.classList.toggle("expanded");
    window.scrollTo({ left: 0, top: YAxis });
}

function showLess(widgetBody, bodyDescription) {
    widgetBody.classList.remove("expanded");
    bodyDescription.scrollIntoView();
}

function createOnIntersect(context) {
    return function onIntersect(entry) {
        let bodyDescription, widgetBody, readMoreContainer;
        const { target } = entry;
        if (target.dataset.keepReadyInitiated) {
            return;
        }
        target.dataset.keepReadyInitiated = true;

        if (target.dataset.closestWidget) {
            widgetBody = target.closest(target.dataset.closestWidget);
            readMoreContainer = widgetBody.querySelector(".js-appear-on-expand");
            bodyDescription = readMoreContainer.parentElement;
        } else {
            bodyDescription = target.parentElement;
            widgetBody = bodyDescription.closest(".js-expandable");
            readMoreContainer = bodyDescription.querySelector(".js-appear-on-expand");
        }

        parseContents(readMoreContainer);
        target.addEventListener("click", (event) => {
            if (event.target.matches(".show-less")) {
                showLess(widgetBody, bodyDescription);
            } else {
                showMore(widgetBody);
                publishReadArticle({ ...widgetBody.dataset, ...context });
            }
        });
    };
}

export default function initKeepReadingView(context) {
    createSmartIntersector(context.intersectionObserverProvider, {
        initialThreshold: 200,
        onIntersect: createOnIntersect(context),
        selector: ".js-keep-reading",
    });
    return context;
}
